module.exports = __webpack_public_path__ + "static/whiteboard.09b1b40e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Curro/whiteboard.png
// module id = 56
// module chunks = 41575166079411 160870767912026 188029690210722